/* global axios */
import ApiClient from './ApiClient';

class VoipDispositionConfigAPI extends ApiClient {
  constructor() {
    super('voip_disposition_config', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  update(payload) {
    return axios.patch(this.url, { voip_disposition_config: payload });
  }
}

export default new VoipDispositionConfigAPI();
